"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.totalCountReducer = void 0;
const totalCount_1 = require("../actions/totalCount");
const totalCountReducer = (count = 0, action) => {
    return action.type === totalCount_1.SET_TOTAL_COUNT ? action.payload : count;
};
exports.totalCountReducer = totalCountReducer;
//# sourceMappingURL=totalCount.reducer.js.map